var _defs, _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKiinteistokartturiSmall(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 325.81 120.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#004991;}.cls-2{fill:#00aec8;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Kiinteist\xF6kartturi") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M65.63,17.57,20.79,59.15v46.43L67.57,60.64l.28-44A3.41,3.41,0,0,0,65.63,17.57Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M70.39,17.56a3.49,3.49,0,0,0-2.54-.91l-.28,44,0,0,47.48,44.87.2-46.33Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160,17.58,115.27,59.15h0l-.2,46.33.11.1,47.09-45-.09-43.95A3.45,3.45,0,0,0,160,17.58Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M255.37,16.18,209.48,59.07v46.5h0l47-44.93-.1-44.79A1.26,1.26,0,0,0,255.37,16.18Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.75,105.58V59.09L257.13,16.17a1.29,1.29,0,0,0-.74-.31l.1,44.79,0,0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M209.42,59.13,164.79,17.58a3.48,3.48,0,0,0-2.61-.92l.09,44h0l47.21,45V59.07Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiinteistokartturiSmall);
export default __webpack_public_path__ + "static/media/kiinteistokartturi-small.db8d8de219b73cc8c6f417e01e1a35a1.svg";
export { ForwardRef as ReactComponent };